import { Row } from '@tanstack/react-table'
import { useCombinedLogsTableStateStore } from '../store'
import { Log } from '@/types/logs'
import { useClickOutside } from '@/helpers/useClickOutside'

export const useHandleShiftClick = () => {
    const { multipleSelection, setMultipleSelection } = useCombinedLogsTableStateStore()

    const handleShiftClick = (_event: React.MouseEvent<HTMLTableRowElement>, row: Row<Log>) => {
        if (multipleSelection.some((log) => log.id === row.original.id)) {
            setMultipleSelection(multipleSelection.filter((log) => log.id !== row.original.id))
        } else {
            setMultipleSelection([...multipleSelection, row.original])
        }
    }

    const handleClickAwayFromEditForm = () => {
        setMultipleSelection([])
    }

    const logContainerRef = useClickOutside<HTMLDivElement>(() => handleClickAwayFromEditForm(), true)

    return {
        handleShiftClick,
        logContainerRef,
        multipleSelection,
    }
}
